module.exports = __webpack_public_path__ + "static/media/Cambodia.13e4eada.png";